'use client'

import { Field, Button, Text } from '@/design-system'
import { AuthErrorMessage } from './AuthErrorMessage'
import { GoogleButton } from './GoogleButton'
import { VerificationStep } from './VerificationStep'
import { useSignUpForm } from '@/hooks/auth/useSignUpForm'

export function SignUpForm() {
  const {
    firstName,
    lastName,
    email,
    password,
    isLoading,
    error,
    step,
    setField,
    handleSubmit,
    submitCode,
    resendCode,
    goBack
  } = useSignUpForm()

  if (step === 'verification') {
    return (
      <VerificationStep
        email={email}
        isLoading={isLoading}
        error={error}
        onSubmit={submitCode}
        onResend={resendCode}
        onBack={goBack}
      />
    )
  }

  const emailError = error === 'email_address_exists'

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault()
        handleSubmit()
      }}
      style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <GoogleButton />
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          margin: '4px 0'
        }}>
        <div style={{ flex: 1, height: 2, background: 'var(--ink)', opacity: 0.15 }} />
        <Text as="span" variant="overline" opacity={0.6}>
          or
        </Text>
        <div style={{ flex: 1, height: 2, background: 'var(--ink)', opacity: 0.15 }} />
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
        <Field
          label="First name"
          type="text"
          value={firstName}
          onChange={(val) => setField('firstName', val)}
          placeholder="Jane"
          autoComplete="given-name"
        />
        <Field
          label="Last name"
          type="text"
          value={lastName}
          onChange={(val) => setField('lastName', val)}
          placeholder="Doe"
          autoComplete="family-name"
        />
      </div>

      <div>
        <Field
          label="Email"
          type="email"
          value={email}
          onChange={(val) => setField('email', val)}
          placeholder="you@example.com"
          autoComplete="email"
        />
        {emailError && (
          <div style={{ marginTop: 6 }}>
            <AuthErrorMessage code={error} />
          </div>
        )}
      </div>

      <Field
        label="Password"
        type="password"
        value={password}
        onChange={(val) => setField('password', val)}
        placeholder="••••••••"
        autoComplete="new-password"
      />

      {error && !emailError && (
        <div style={{ textAlign: 'center' }}>
          <AuthErrorMessage code={error} />
        </div>
      )}

      <div style={{ marginTop: 4 }}>
        <Button
          type="submit"
          variant="primary"
          disabled={isLoading}
          style={{ width: '100%', justifyContent: 'center' }}>
          {isLoading ? 'Creating account…' : 'Create account →'}
        </Button>
      </div>

      {/* Clerk renders its Smart CAPTCHA (Cloudflare Turnstile) into this element
          when bot protection is enabled. Without it the SDK falls back to an
          invisible about:srcdoc CAPTCHA whose inline script our CSP frame-src
          blocks → the request 422s on production. Same fix as AcceptInviteForm. */}
      <div id="clerk-captcha" />
    </form>
  )
}
